import React, { useState } from 'react';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CalendarIcon } from '@heroicons/react/24/outline';
import dayjs from 'dayjs';
import 'dayjs/locale/ro';

const DateStep = ({ selectedDate, onSelect, isDesktop = false }) => {
  const [isOpen, setIsOpen] = useState(false);

  // Function to disable weekend dates (Saturday is 6, Sunday is 0)
  const isWeekend = (date) => {
    const day = date.day();
    return day === 0 || day === 6;
  };

  const darkTheme = createTheme({
    palette: {
      mode: document.documentElement.classList.contains('dark') ? 'dark' : 'light',
      primary: {
        main: '#7e22ce', // purple-600
      },
      background: {
        paper: document.documentElement.classList.contains('dark') ? '#1f2937' : '#ffffff',
      },
      text: {
        primary: document.documentElement.classList.contains('dark') ? '#f3f4f6' : '#111827',
      }
    },
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            borderRadius: '12px',
            boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
          }
        }
      }
    }
  });

  return (
    <div className={`${isDesktop ? '' : 'max-w-md mx-auto'}`}>
      {!isDesktop && (
        <h3 className="mb-3 font-medium text-gray-800 dark:text-gray-100 text-base">
          Data
        </h3>
      )}
      
      <div className="relative">
        <ThemeProvider theme={darkTheme}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              value={selectedDate}
              onChange={onSelect}
              disablePast
              shouldDisableDate={isWeekend}
              format="DD MMMM YYYY"
              slotProps={{
                textField: {
                  fullWidth: true,
                  variant: "outlined",
                  placeholder: "Selectează data",
                  InputProps: {
                    startAdornment: (
                      <CalendarIcon className="h-5 w-5 text-purple-600 dark:text-purple-400 mr-3" />
                    ),
                  },
                  sx: {
                    '& .MuiOutlinedInput-root': {
                      backgroundColor: 'white',
                      borderRadius: '8px',
                      border: '1px solid rgb(209, 213, 219)',
                      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
                      transition: 'all 0.2s',
                      '&:hover': {
                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                        borderColor: 'rgb(156, 163, 175)',
                      },
                      '&.Mui-focused': {
                        borderColor: '#7e22ce',
                        boxShadow: '0 0 0 3px rgba(126, 34, 206, 0.1)',
                      },
                      '& fieldset': {
                        border: 'none',
                      },
                      '& input': {
                        padding: '12px 16px',
                        fontSize: '0.95rem',
                        fontWeight: 500,
                        color: document.documentElement.classList.contains('dark') ? '#f3f4f6' : '#1f2937',
                      }
                    },
                    ...(document.documentElement.classList.contains('dark') && {
                      '& .MuiOutlinedInput-root': {
                        backgroundColor: 'rgb(31, 41, 55)',
                        borderColor: 'rgb(75, 85, 99)',
                        '&:hover': {
                          borderColor: 'rgb(107, 114, 128)',
                        },
                        '&.Mui-focused': {
                          borderColor: '#7e22ce',
                          boxShadow: '0 0 0 3px rgba(126, 34, 206, 0.1)',
                        },
                      }
                    })
                  }
                },
                popper: {
                  sx: {
                    '& .MuiPaper-root': {
                      marginTop: '8px',
                    }
                  }
                }
              }}
            />
          </LocalizationProvider>
        </ThemeProvider>
      </div>
    </div>
  );
};

export default DateStep;
